export const SET_LOCALIZATION = "SET_LOCALIZATION";

export const setLocalization = (locale) => ({
  type: SET_LOCALIZATION,
  locale
});
